import React, { useEffect, useState, useRef } from "react";
import IconButton from "@material-ui/core/IconButton";

import GreenButton from "../cinema-draft-button/cinema-draft-button.component";
import axios from "axios";
import * as actions from "../../actions";
import { Input, Tooltip, Progress, InfoCircleOutlined, Button } from "antd";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { BuysellStyle } from "./style";
import exchange from "../../public/Exchange - Icon.svg";
import arrow from "../../public/Button - Icon.svg";
import arrow2 from "../../public/Button - Icon (2).svg";
import Buypopup from "../buypopup/buypopup";
import Transferpopup from "../transferpopup/transferpopup";
import { connect } from "react-redux";
import Contract_obj from "../../getTronweb";
import Sellpopup from "../sellpopup";
import AlertDialogSlide from "../infoBox";
import input_icon from "../../public/input_icon.png";
import convert_icon from "../../public/convert.png";
import styless from "./progress.module.scss";
import metacoinConfig from "../../metacoin-config.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import { notification } from "antd";
import TronGrid from "trongrid";
import ConnectionModal from "../connectionpopup";
import AnimatedButton from "../AnimatedButton";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const Buysell = ({
  theme,
  contract,
  accounts,
  updated,
  setUpdated,
  timer,
  ...props
}) => {
  const [trx, setTrx] = useState();
  const [trxToTokens, setTrxToTokens] = useState();
  const [tokens, setTokens] = useState();
  const [trxPerToken, setTrxPerToken] = useState();
  const [usd, setUsd] = useState();
  const [usdToSpend, setUsdToSpend] = useState(0);
  const [open, setmodal] = useState(false);
  const [openSell, setSell] = useState(false);
  const [loss, setLoss] = useState();
  const [openTransfer, setOpentransfer] = useState(false);
  const [receipeintAddress, setReceipeintAddress] = useState();
  const [progress, setProgress] = useState(0);
  const [ledger, setLedger] = useState([]);
  const [gantChart, setGantChart] = useState();
  const [totalLoss, setTotalLoss] = useState();
  const [ref_address, setRefAddress] = useState();
  const [trons, setTrons] = useState();
  const [recent, setRecent] = useState();
  const [showInfo, setShowInfo] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [trongrid, setTrongrid] = useState();
  const mounted = useRef();
  const [timestamp_arr, set_timestamp_arr] = useState([]);
  const [connectModal, setConnectModal] = useState(false);
  const [connection_issue, setConnectionIssue] = useState(0);
  const [err, handleCloseErr] = useState(false);
  const [err_msg, set_err_msg] = useState("Error");
  const [accBalance, setAccBalance] = useState();
  const [positions, setPositions] = React.useState({
    vertical: "top",
    horizontal: "center",
  });

  const { vertical, horizontal } = positions;
  const handleClose = () => {
    setmodal(false);
  };

  const handleCloseTransfer = () => {
    setOpentransfer(false);
  };

  const fetchData = async () => {
    setProcessing(false);
    window.tronWeb && await Contract_obj.init(window.tronWeb.fullNode.host == "https://api.shasta.trongrid.io"
    ? "shasta"
    : "mainnet");
    // console.log(Contract_obj,"Contract_obj")

    setTrx(null);
    setTrxToTokens(null);
    setTrons(null);
    (await Contract_obj.contract_instace) &&
      Contract_obj.contract_instace
        .myTokens()
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit,
          callValue: Contract_obj.callValue || 0,
        })
        .then(function (res) {
          if (res) {
            setTokens(res.toString());
          }
        });

    theme < 2
      ? (await Contract_obj.contract_instace) &&
        Contract_obj.contract_instace
          .buyPrice()
          .call({
            from: Contract_obj.accounts[0],
            feeLimit: Contract_obj.feeLimit,
          })
          .then(function (res) {
            if (res) {
              // console.log(res.toString(), "Price buy");
              setTrxPerToken(res.toString());
            }
          })
      : (await Contract_obj.contract_instace) &&
        Contract_obj.contract_instace
          .sellPrice()
          .call({
            from: Contract_obj.accounts[0],
            feeLimit: Contract_obj.feeLimit,
          })
          .then(function (res) {
            if (res) {
              // console.log(res.toString(), "Price sell");
              setTrxPerToken(res.toString());
            }
          });

    (await Contract_obj.contract_instace) &&
      Contract_obj.contract_instace
        .getCursor()
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit,
        })
        .then(async res => {
          if (res) {
            // console.log(res, typeof res, "cursor");
            var start = parseInt(res[0].toString());
            var end = parseInt(res[1].toString());
            // console.log(start, end);
          }

          var temp = [];
          var i = start;
          var gant_chart = {
            0: { value: 0, days: 0, percent: 0 },
            25: { value: 0, days: 0, percent: 0 },
            50: { value: 0, days: 0, percent: 0 },
            75: { value: 0, days: 0, percent: 0 },
          };
          for (i = start; i < end; i++) {
            Contract_obj.contract_instace &&
              (await Contract_obj.contract_instace
                .getTimestampedBalanceLedger(i)
                .call({
                  from: Contract_obj.accounts[0],
                  feeLimit: Contract_obj.feeLimit,
                })
                .then(res => {
                  if (res) {
                    //store value , valueSOld ,   timestamp
                    if (!timestamp_arr.includes(res[1].toString())) {
                      temp.push({
                        value: res[0].toString(),
                        valueSold: res[2].toString(),
                        timestamp: res[1].toString(),
                      });
                      let temp_timestamp = timestamp_arr;
                      temp_timestamp.push(temp.timestamp);
                      set_timestamp_arr(temp_timestamp);
                      setLedger(temp);
                    }
                    if (temp.length == end - start) {
                      var today = parseInt(
                        new Date().getTime().toString().slice(0, -3)
                      );
                      temp.forEach(val => {
                        if (today - val.timestamp >= 2592000) {
                          gant_chart["0"].value += val.value - val.valueSold;
                        } else if (today - val.timestamp >= 1728001) {
                          gant_chart["25"].value += val.value - val.valueSold;
                        } else if (today - val.timestamp >= 864001) {
                          gant_chart["50"].value += val.value - val.valueSold;
                          gant_chart["50"].days = Math.max(
                            today - val.timestamp,
                            gant_chart["50"].days
                          );
                        } else {
                          gant_chart["75"].value += val.value - val.valueSold;
                          gant_chart["75"].days = Math.max(
                            today - val.timestamp,
                            gant_chart["75"].days
                          );
                        }
                        // console.log(gant_chart, "chart", today - val.timestamp);
                      });

                      setGantChart(gant_chart);
                    }
                  }
                }));
          }
          // setLedger(temp)
        });
    var ref_name_stored = localStorage.getItem("ref_name")
    
    if (ref_name_stored) {
      var str = "0x";
      var i;
      var ref_name = ref_name_stored;
      if (ref_name.length != 34) {
        for (i = 0; i < ref_name.length; i++) {
          str = str.concat(ref_name.charCodeAt(i).toString(16));
        }
        str = str.padEnd(66, "0");
        (await Contract_obj.contract_instace) &&
          Contract_obj.contract_instace
            .getReferralAddressForName(str)
            .call({
              from: Contract_obj.accounts[0],
              feeLimit: Contract_obj.feeLimit,
            })
            .then(function (res) {
              if (res) {
                // console.log(
                //   res.toString(16),
                //   "ref address",
                //   Contract_obj.accounts[0]
                // );
                setRefAddress(res.toString());
              }
            });
      } else {
        setRefAddress(ref_name);
      }
    }
  };
  useEffect(() => {
    window.addEventListener("message", function (e) {
      if (e.data.message && e.data.message.action == "setNode") {
        // console.log("setNode event", e.data.message);

        if (
          window.tronWeb &&
          (window.tronWeb.fullNode.host == metacoinConfig["mainnet"].fullHost ||
            window.tronWeb.fullNode.host == metacoinConfig["shasta"].fullHost)
        ) {
          fetchData();
        }
      }
    });
    Contract_obj.contract_instace && fetchData();
  }, []);

  useEffect(() => {
    Contract_obj.contract_instace && fetchData();
  }, [updated, theme]);
  useEffect(() => {
    if (!mounted.current) {
      // do componentDidMount logic
      mounted.current = true;
    } else {
      // console.log("updated");

      Contract_obj.contract_instace && fetchData();
    }
  }, [window.location.pathname]);

  const chechConnection = async v => {
    console.log(Contract_obj, "Contract_obj_")
    if (
      !window.tronWeb ||
      (window.tronWeb && window.tronWeb.defaultAddress.hex == false)
    ) {
      setConnectModal(true);
    } else if (
      window.tronWeb &&
      (window.tronWeb.fullNode.host != metacoinConfig["mainnet"].fullHost &&
      window.tronWeb.fullNode.host != metacoinConfig["shasta"].fullHost)
  
    ) {
      setConnectionIssue(1);
      setConnectModal(true);
    } else {
      window.tronWeb &&
        (await window.tronWeb.trx
          .getBalance(Contract_obj.accounts[0])
          .then(result => {
            console.log(result, "balance",v,trx);
            setAccBalance(result);
          }));
      if (v == 1 && trx) {
        setmodal(true);
      } else if (v == 2 && trxToTokens) {
        setSell(true);
      } else if (v == 3 && receipeintAddress && trxToTokens) {
        setOpentransfer(true);
      }
    }
  };

  const setDisabled = v => {
    if (
      !window.tronWeb ||
      (window.tronWeb && window.tronWeb.defaultAddress.hex == false)
    ) {
      return false;
    } else if (
      window.tronWeb &&
      window.tronWeb.fullNode.host != metacoinConfig.fullHost
    ) {
      return false;
    } else if (processing) {
      return true;
    } else {
      if (v == 1 && trx) {
        return false;
      } else if (v == 2 && trxToTokens) {
        return false;
      } else if (v == 3 && receipeintAddress && trxToTokens) {
        return false;
      } else {
        return true;
      }
    }
  };
  const buy = async () => {
    //contract.[eventname].watch(callback) enventname is the name of the event of the contract

    try {
      var res = await Contract_obj.buyFunc(trx * 1e6, ref_address);
      // console.log("tron buy", Contract_obj, res);
      // setUpdated(updated + 1);
      setProcessing(true);

      setTimeout(async () => {
        setUpdated(updated + 1);
        setTrx("");
        setTrxToTokens("");
        setUsdToSpend("");
        setRefAddress()
        localStorage.removeItem('ref_name');
      }, 5000);
    } catch (error) {
      // console.log("err");
      setProcessing(false);
      set_err_msg("You don't have sufficient balance in your account!");
      handleCloseErr(true);
    }
  };

  const sell = async () => {
    try {
      var res = await Contract_obj.sellFunc(trxToTokens);
      // console.log("sell", res);
      setSell(false);
      setProcessing(true);

      // setUpdated(updated + 1);

      setTimeout(async () => {
        setUpdated(updated + 1);
        setTrx("");
        setTrxToTokens("");
        setUsdToSpend("");
        setProgress(0);
        setLoss("");
        setTotalLoss("");
      }, 5000);
    } catch (error) {
      setProcessing(false);
      set_err_msg("You don't have enough CETO!");
      handleCloseErr(true);
    }
  };
  const transfer = async () => {
    try {
      var res = await Contract_obj.transferFunc(receipeintAddress, trxToTokens);
      // console.log("transferFunc", res);
      setReceipeintAddress();
      setProcessing(true);

      setOpentransfer(false);
      // setUpdated(updated + 1);

      setTimeout(async () => {
        setUpdated(updated + 1);
        setTrx("");
        setTrxToTokens("");
        setUsdToSpend("");
        setProgress(0);
        setLoss("");
        setTotalLoss("");
        setReceipeintAddress("");
      }, 5000);
    } catch (error) {
      setProcessing(false);
      set_err_msg("You don't have enough CETO!");
      handleCloseErr(true);
    }
  };
  const convert = async value => {
    setTrx(value);
    
    value = value * 1e6;
    Contract_obj.contract_instace &&
      (await Contract_obj.contract_instace
        .calculateTokensReceived(value)
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit,
          callValue: Contract_obj.callValue || 0,
        })
        .then(function (res) {
          if (res) {
            // console.log(res.toString(), "CETO TOKENS");
            setTrxToTokens(res.toString());
            setUsdToSpend(
              ((value * props.utils.currencies.USD) / 1e6).toFixed(2)
            );
          }
        }));
  };

  const convert_ceto = async value => {
    // try {
    // console.log("valuee", typeof value);

    setTrxToTokens(value);
    if (value && value * 1e6 < tokens && value > 0 && value != "") {
      // console.log("value", value);

      value = value * 1e6;

      await Contract_obj.contract_instace
        .calculateTronReceived(value)
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit,
        })
        .then(function (res) {
          if (res) {
            setTrx(res.toString());
            setUsd(
              (
                (parseInt(res.toString()) / 1e6) *
                props.utils.currencies.USD
              ).toFixed(2)
            );
          }
        });
      await Contract_obj.contract_instace
        .calculateAveragePenalty(value, Contract_obj.accounts[0])
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit,
        })
        .then(function (res) {
          if (res) {
            Contract_obj.contract_instace
              .tokensToTron_(value)
              .call({
                from: Contract_obj.accounts[0],
                feeLimit: Contract_obj.feeLimit,
              })
              .then(function (tron) {
                setTrons(tron);
                var penalty =
                  parseInt(res.toString()) * parseInt(tron.toString());
                penalty = penalty / 100;
                setTotalLoss(penalty);
              });
            setLoss(res.toString());
          }
        });
      var i = 0;
      value = parseInt(value);
      var gant_chart = gantChart;
      while (value > 0 && i <= 75) {
        if (gant_chart[i.toString()].value > 0) {
          gant_chart[i.toString()].percent =
            (value / gant_chart[i.toString()].value) * 100;

          value = value - gant_chart[i.toString()].value;
        } else {
          gant_chart[i.toString()].percent = 100;
        }
        i = i + 25;
      }

      var progress_ =
        gant_chart["0"].percent / 4 +
        gant_chart["25"].percent / 4 +
        gant_chart["50"].percent / 4 +
        gant_chart["75"].percent / 4;

      setProgress(progress_);
    } else {
      setTrxToTokens(value);
      setProgress(0);
      setTrx();
      setUsdToSpend();
      setLoss();
      setTotalLoss();
    }
    if (value.length == 0 || value == null) {
      setProgress(0);
    }
    if (value > tokens / 1e6) {
      set_err_msg("You don't have enough CETO!");
      handleCloseErr(true);
    } else {
      set_err_msg("");
      handleCloseErr(false);
    }
  };

  useEffect(() => {
    // console.log(progress, trxToTokens, typeof trxToTokens);
    if (trxToTokens == "") {
      setProgress(0);
      setLoss();
      setTotalLoss();
      setTrx("");
    }
  }, [progress]);

  const toDays = sec => {
    if (sec == 0) {
      return 0;
    }
    return Math.round((2592000 - sec) / (24 * 3600));
  };
  const convert_ = async value => {
    if (value > tokens / 1e6) {
      set_err_msg("You don't have enough CETO!");
      handleCloseErr(true);
    } else {
      set_err_msg("");
      handleCloseErr(false);
    }
    try {
      setTrxToTokens(value);
      value = value * 1e6;

      await Contract_obj.contract_instace
        .calculateTronTransferred(value)
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit,
        })
        .then(async res => {
          if (res) {
            setTrx(res.toString());
            await Contract_obj.contract_instace
              .tokensToTron_(res.toString())
              .call({
                from: Contract_obj.accounts[0],
                feeLimit: Contract_obj.feeLimit,
              })
              .then(function (tron) {
                setUsdToSpend(
                  (
                    parseInt(tron.toString()) * props.utils.currencies.USD
                  ).toFixed(2)
                );
              });
          }
        });
      await Contract_obj.contract_instace
        .calculateAveragePenalty(value, Contract_obj.accounts[0])
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit,
        })
        .then(function (res) {
          if (res) {
            // console.log(res.toString(), "losss");

            var penalty = parseInt(res.toString()) * value;
            penalty = penalty / 100;
            // console.log("penalty", penalty);
            setTotalLoss(penalty);

            setLoss(res.toString());
          }
        });
    } catch {
      setProgress(0);
      setTrx(null);
      setUsdToSpend(0);
      setLoss();
      setTotalLoss();
    }
  };

  return (
    <>
      <BuysellStyle theme={theme} width={props.width && props.width}>
        <div className={`buysell_container ${theme > 1 ? "newtheme" : ""}`}>
          <div className="upper">
            <span className="light">
              {theme <= 1 ? "Buy" : theme == 2 ? "Sell" : "Transfer"} CETO
            </span>
            <span className="lmobile">
              {theme <= 1 ? "Buy" : theme == 2 ? "Sell" : "Transfer"} CETO
            </span>
            {/* <span className="medium">
              {trxPerToken && (trxPerToken / 1e6).toFixed(3)} TRX/CETO
            </span> */}
          </div>
          <div className="flex1">
            <div className="txt11">
              Enter {theme <= 1 ? "TRX" : "CETO"} Value
            </div>
            <div className="txt11 right ss">
              {theme <= 1
                ? "CETO You Get"
                : theme == 2
                ? "Amount You Get"
                : "They Get"}
            </div>
          </div>
          <div className="convert">
            <Input
              className="inputText"
              prefix={
                <img
                  src={
                    theme <= 1
                      ? "https://res.cloudinary.com/dgdjabqwr/image/upload/v1610200564/cd3d/Group_5257_xyltnd.svg"
                      : input_icon
                  }
                />
              }
              type="number"
              value={theme <= 1 ? trx : trxToTokens}
              onChange={e =>
                Contract_obj.contract_instace &&
                (theme <= 1
                  ? convert(e.target.value)
                  : theme == 2
                  ? convert_ceto(e.target.value)
                  : convert_(e.target.value))
              }
            />

            <button className={`convertbutton`}>
              <img src={convert_icon} />
            </button>

            <Input
              className="resultText"
              suffix={
                <img
                  src={
                    theme == 2
                      ? "https://res.cloudinary.com/dgdjabqwr/image/upload/v1610200564/cd3d/Group_5257_xyltnd.svg"
                      : input_icon
                  }
                />
              }
              type="number"
              value={
                theme <= 1
                  ? trxToTokens && (trxToTokens / 1e6).toFixed(6)
                  : trx && (trx / 1e6).toFixed(6)
              }
            />
          </div>
          {theme <= 1 ? (
            <p className={`medium  rt`}>
              Approximately {usdToSpend} USD to Spend
            </p>
          ) : theme == 2 ? (
            <div classname={`loss_info`}>
              <span className="txt2">
                At loss of {loss && loss}% | Total Loss:{" "}
                {totalLoss && totalLoss / 1e6} {theme == 2 ? "TRX" : "CETO"}
              </span>
              <IconButton
                color="primary"
                style={{ padding: 0 }}
                onClick={() => setShowInfo(true)}
              >
                <HelpOutlineIcon
                  style={{
                    color: "#1FD0FF",
                    width: "18px",
                    height: "18px",
                    margin: "0 10px",
                  }}
                />
              </IconButton>
            </div>
          ) : (
            <p className={`medium  rt`}>
              Approximately {usdToSpend && (usdToSpend / 1e6).toFixed(2)} USD to
              transfer
            </p>
          )}
          {theme == 3 ? (
            <div className="receipeintdiv">
              <p className={`medium`}>Recipient Wallet</p>
              <input
                className="inputText"
                type="text"
                value={receipeintAddress}
                onChange={e => setReceipeintAddress(e.target.value)}
              />
            </div>
          ) : null}
          <div class="wrapper">
            <div class="bg">
              <div class="el"></div>
            </div>
          </div>
          {theme == 2 && (
            <div className="Block l">
              <Progress
                strokeColor={{
                  "0%": "#AACAFB",
                  25: "#90DACC",
                  "50%": "#96F6AB",
                  "75%": "#FFE384",
                }}
                percent={progress}
                status="active"
              />
              <div className="abs">
                <div className="progress-block">
                  <div className="block">
                    <div className="txt1">Available Today</div>
                    <div className="txt2">
                      {gantChart && (gantChart["0"].value / 1e6).toFixed(2)}{" "}
                      <span>CETO</span>
                    </div>

                    <div className="txt3">100% today</div>
                  </div>
                  <div className="block">
                    <div className="txt1">25% Loss</div>
                    <div className="txt2">
                      {gantChart && (gantChart["25"].value / 1e6).toFixed(2)}{" "}
                      <span>CETO</span>
                    </div>
                    <div className="txt3">
                      100% in ~{gantChart && toDays(gantChart["25"].days)} days
                    </div>
                  </div>
                  <div className="block">
                    <div className="txt1">50% Loss</div>
                    <div className="txt2">
                      {gantChart && (gantChart["50"].value / 1e6).toFixed(2)}{" "}
                      <span>CETO</span>
                    </div>
                    <div className="txt3">
                      100% in ~{gantChart && toDays(gantChart["50"].days)} days
                    </div>
                  </div>
                  <div className="block">
                    <div className="txt1">75% Loss</div>
                    <div className="txt2">
                      {gantChart && (gantChart["75"].value / 1e6).toFixed(2)}{" "}
                      <span>CETO</span>
                    </div>
                    <div className="txt3">
                      100% in ~{gantChart && toDays(gantChart["75"].days)} days
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}{" "}
          {theme == 2 && (
            <div className="btm l">
              <div className="chip">
                {theme == 2 ? "Selling" : "Transferring"}{" "}
                {gantChart && gantChart["0"].percent.toFixed()}%
              </div>
              <div className="chip">
                {theme == 2 ? "Selling" : "Transferring"}{" "}
                {gantChart && gantChart["25"].percent.toFixed()}%
              </div>
              <div className="chip">
                {theme == 2 ? "Selling" : "Transferring"}{" "}
                {gantChart && gantChart["50"].percent.toFixed()}%
              </div>

              <div className="chip">
                {theme == 2 ? "Selling" : "Transferring"}{" "}
                {gantChart && gantChart["75"].percent.toFixed()}%
              </div>
            </div>
          )}
          {theme <= 1 ? (
            <div
              id="button-wrappered"
              className={`${processing ? "checked" : ""}`}
              onClick={() => !processing && chechConnection(1)}
              style={{
                cursor: setDisabled(1) && "not-allowed",
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                {" "}
                <defs>
                  {" "}
                  <filter id="goo">
                    {" "}
                    <feGaussianBlur
                      in="SourceGraphic"
                      stdDeviation="10"
                      result="blur"
                    />{" "}
                    <feColorMatrix
                      in="blur"
                      mode="matrix"
                      values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
                      result="goo"
                    />{" "}
                    <feBlend in="SourceGraphic" in2="goo" />{" "}
                  </filter>{" "}
                </defs>
              </svg>
              <p className={`${processing ? "submited circle" : "submited"}`}>
                Buy Ceto{" "}
                <img
                  className={`${processing ? "hideArrow" : ""}`}
                  src={arrow}
                />
              </p>
              <div className="loader-wrapper">
                <span className="loader yellow"></span>
                <span className="loader pink"></span>
              </div>
              <span className="loader orange"></span>

              <div className="check-wrapper">
                <svg
                  version="1.1"
                  width="65px"
                  height="38px"
                  viewBox="0 0 64.5 37.4"
                >
                  <polyline className="check" points="5,13 21.8,32.4 59.5,5 " />
                </svg>
              </div>
            </div>
          ) : // <AnimatedButton
          //   loading={processing}
          //   onClick={e => {
          //     !processing && chechConnection(1);
          //   }}
          // />
          // <GreenButton
          //   style={{
          //     background: "#ffffff",
          //     color: "#002E8C",
          //     marginTop: "37px",
          //     cursor: setDisabled(1) && "not-allowed"
          //   }}
          //   onClick={() => !processing && chechConnection(1)}
          // >
          //   Buy CETO
          //   {processing ? (
          //     <CircularProgress
          //       width={28}
          //       height={28}
          //       style={{ width: "28px", height: "28px", marginLeft: "1rem" }}
          //     />
          //   ) : (
          //     <img src={arrow} />
          //   )}
          // </GreenButton>
          theme == 2 ? (
            <div
              id="button-wrappered"
              className={`${processing ? "checked" : ""}`}
              onClick={() => !processing && chechConnection(2)}
              style={{
                cursor: setDisabled(1) && "not-allowed",
                color: "white",
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                {" "}
                <defs>
                  {" "}
                  <filter id="goo">
                    {" "}
                    <feGaussianBlur
                      in="SourceGraphic"
                      stdDeviation="10"
                      result="blur"
                    />{" "}
                    <feColorMatrix
                      in="blur"
                      mode="matrix"
                      values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
                      result="goo"
                    />{" "}
                    <feBlend in="SourceGraphic" in2="goo" />{" "}
                  </filter>{" "}
                </defs>
              </svg>
              <p
                style={{
                  background: "#009EE4",
                }}
                className={`${processing ? "submited circle" : "submited"}`}
              >
                Sell Ceto{" "}
                <img
                  className={`${processing ? "hideArrow" : ""}`}
                  src={arrow2}
                />
              </p>
              <div className="loader-wrapper">
                <span className="loader blue"></span>
                <span className="loader darkblue"></span>
              </div>
              <span className="loader white"></span>

              <div className="check-wrapper">
                <svg
                  version="1.1"
                  width="65px"
                  height="38px"
                  viewBox="0 0 64.5 37.4"
                >
                  <polyline className="check" points="5,13 21.8,32.4 59.5,5 " />
                </svg>
              </div>
            </div>
          ) : (
            // <GreenButton
            //   style={{
            //     marginTop: "37px",
            //     background: "#009EE4",
            //     cursor: setDisabled(1) && "not-allowed"
            //   }}
            //   onClick={() => !processing && chechConnection(2)}
            // >
            //   Sell CETO
            //   {processing ? (
            //     <CircularProgress
            //       width={28}
            //       height={28}
            //       style={{
            //         width: "28px",
            //         height: "28px",
            //         marginLeft: "1rem",
            //         color: "white"
            //       }}
            //     />
            //   ) : (
            //     <img src={arrow2} />
            //   )}
            // </GreenButton>
            theme == 3 && (
              <div
                id="button-wrappered"
                className={`${processing ? "checked" : ""}`}
                onClick={() => !processing && chechConnection(3)}
                style={{
                  cursor: setDisabled(1) && "not-allowed",
                  color: "white",
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                  {" "}
                  <defs>
                    {" "}
                    <filter id="goo">
                      {" "}
                      <feGaussianBlur
                        in="SourceGraphic"
                        stdDeviation="10"
                        result="blur"
                      />{" "}
                      <feColorMatrix
                        in="blur"
                        mode="matrix"
                        values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
                        result="goo"
                      />{" "}
                      <feBlend in="SourceGraphic" in2="goo" />{" "}
                    </filter>{" "}
                  </defs>
                </svg>
                <p
                  style={{
                    background: "#009EE4",
                  }}
                  className={`${processing ? "submited circle" : "submited"}`}
                >
                  Transfer Ceto{" "}
                  <img
                    className={`${processing ? "hideArrow" : ""}`}
                    src={arrow2}
                  />
                </p>
                <div className="loader-wrapper">
                  <span className="loader yellow"></span>
                  <span className="loader pink"></span>
                </div>
                <span className="loader orange"></span>

                <div className="check-wrapper">
                  <svg
                    version="1.1"
                    width="65px"
                    height="38px"
                    viewBox="0 0 64.5 37.4"
                  >
                    <polyline
                      className="check"
                      points="5,13 21.8,32.4 59.5,5 "
                    />
                  </svg>
                </div>
              </div>
              // <GreenButton
              //   style={{
              //     marginTop: "37px",
              //     background: "#009EE4",
              //     cursor: setDisabled(1) && "not-allowed"
              //   }}
              //   onClick={() => !processing && chechConnection(3)}
              // >
              //   Transfer CETO
              //   {processing ? (
              //     <CircularProgress
              //       width={28}
              //       height={28}
              //       style={{
              //         width: "28px",
              //         height: "28px",
              //         marginLeft: "1rem",
              //         color: "white"
              //       }}
              //     />
              //   ) : (
              //     <img src={arrow2} />
              //   )}
              // </GreenButton>
            )
          )}
        </div>
      </BuysellStyle>
      <Buypopup
        open={open}
        handleClose={handleClose}
        trx={trx}
        trxToTokens={trxToTokens}
        buy={buy}
        usdToSpend={usdToSpend}
        accBalance={accBalance}
      />
      <Transferpopup
        open={openTransfer}
        handleClose={handleCloseTransfer}
        transfer={transfer}
        receipeintAddress={receipeintAddress}
        trxToTokens={trxToTokens}
        totalLoss={totalLoss}
        trx={trx}
        accBalance={accBalance}
      />
      <Sellpopup
        open={openSell}
        handleClose={setSell}
        trxToTokens={trxToTokens}
        trx={trx}
        usd={usd}
        penalty={totalLoss}
        sell={sell}
        tokens={tokens}
        trons={trons}
        timer={timer}
        accBalance={accBalance}
      />
      <AlertDialogSlide
        theme={theme}
        showInfo={showInfo}
        setShowInfo={setShowInfo}
      ></AlertDialogSlide>
      <ConnectionModal
        openModal={connectModal}
        connection_issue={connection_issue}
        setConnectModal={setConnectModal}
      />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={err}
        autoHideDuration={6000}
        onClose={() => handleCloseErr(false)}
      >
        <Alert onClose={() => handleCloseErr(false)} severity="error">
          {err_msg}
        </Alert>
      </Snackbar>
    </>
  );
};

const mapStateToProps = state => {
  return {
    utils: state.utils,
  };
};

export default connect(mapStateToProps, actions)(Buysell);
